"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSpacingSchemaPropTypes = void 0;

var _reactDesc = require("react-desc");

var _breakpointObserver = require("@decisiv/breakpoint-observer");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var numberOrDynamicModifierProp = _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.number, _reactDesc.PropTypes.shape(_defineProperty({}, _reactDesc.PropTypes.oneOf(['_'].concat(_toConsumableArray(Object.keys(_breakpointObserver.sizes)))), _reactDesc.PropTypes.number))]); // eslint-disable-next-line import/prefer-default-export


var makeSpacingSchemaPropTypes = function makeSpacingSchemaPropTypes() {
  return {
    margin: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on all axis margin.'),
    marginBottom: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the bottom margin.'),
    marginLeft: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the left margin.'),
    marginRight: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the right margin.'),
    marginTop: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the top margin.'),
    marginX: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the X axis margin.'),
    marginY: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the Y axis margin.'),
    padding: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on all axis padding.'),
    paddingBottom: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the bottom padding.'),
    paddingLeft: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the left padding.'),
    paddingRight: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the right padding.'),
    paddingTop: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the top padding.'),
    paddingX: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the X axis padding.'),
    paddingY: numberOrDynamicModifierProp.description('Defines the spacing multiplier for use on the Y axis padding.')
  };
};

exports.makeSpacingSchemaPropTypes = makeSpacingSchemaPropTypes;